import React from 'react';
import PropTypes from 'prop-types';

import Bar from "./components/Bar";

import {black500} from "assets/jss/main";

ProgressBar.propTypes = {
    percentage: PropTypes.number.isRequired,
    height: PropTypes.number,
    label: PropTypes.string,
    variant: PropTypes.oneOf([
        'primary',
        'secondary'
    ])
};

function ProgressBar({percentage = 0, height = 6, variant = 'primary', label = null}) {

    percentage = Math.min(100, Math.max(0, percentage));

    if (variant === 'secondary') {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap:'4px' }}>
                <div style={{display: 'flex', justifyContent: 'space-between', fontSize: '12px'}}>
                    <span style={{color: '#6b7280'}}>{label}</span>
                    <span style={{fontWeight: 'bold', color: black500}}>{percentage}/100</span>
                </div>
                <Bar percentage={percentage} height={height} />
            </div>
        )
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px'}}>
            <Bar percentage={percentage} height={height} />
            <span
                style={{
                    fontSize: '13px',
                    color: '#6b7280',
                    minWidth: '36px',
                }}
            >
                {percentage}%
            </span>
        </div>
    )
}

export default ProgressBar
